// CSRF tokens for API
let token = document.head.querySelector('meta[name="csrf-token"]');
if (!token) {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': token.content,
	},
});

require('./filters.js');
require('./vue.js');

// react
require('./components/ImportLegalEntities.React.js');

(function ($) {
	// jQuery Components
	require('./components/form-validate');
	require('./components/post-button');
	require('./components/script-link');
	require('./components/side-bar');
	require('./components/submit-button');
})(jQuery);

function sendNavigationMessage() {
	const currentURL = window.location.href;
	window.parent.postMessage({ event: 'navigation', url: currentURL }, '*'); // replace star w domain
}

function showNavBar() {
	if (!window.location.href.includes('login')) {
		const nav = document.getElementById('secure-side-nav');
		const navToggle = document.getElementById('side-bar-toggle');
		const secureWrapper = document.getElementById('secure-wrapper');
		secureWrapper.classList.remove('side-bar-toggled');
		secureWrapper.style.paddingLeft = '190px';
		nav.style.display = 'block';
		navToggle.style.display = 'inline-block';
	}
}

function handleMessage(event) {
	if (!event.origin.includes('onboardrs.com')) return;
	if (event.data.event === 'navigation') {
		window.location.href = event.data.url;
	}
}

// Only runs functions if in iframe
if (window.self !== window.top) {
	if (!window.location.href.includes('login')) {
		sendNavigationMessage();
	}

	window.addEventListener('message', handleMessage, false);
} else {
	showNavBar();
}
